import React from 'react';
import './../assets/styles/App.css';
import { Card, CardContent, CardHeader } from '@mui/material';

const Dashboard = () => (
    <Card>
        <CardHeader title="CheckBrand Api Administration" />
        <CardContent>...</CardContent>
    </Card>
);
export default Dashboard;